//Backend URL
export const JAMS_BACKEND_API_URL: string = import.meta.env.VITE_JAMS_BACKEND_URL
export const STAGE: string = import.meta.env.VITE_JAMS_STAGE

// Account Service Usage API (optional)
export const ACCOUNT_SERVICE_USAGE_API_URL: string = import.meta.env.VITE_ACCOUNT_SERVICE_USAGE_API_URL || ''

// Pool Data for Client
export const POOL_DATA_CLIENT = {
  UserPoolId: import.meta.env.VITE_JAMS_CLIENT_USER_POOL_ID,
  ClientId: import.meta.env.VITE_JAMS_CLIENT_CLIENT_ID,
}

// Pool Data for Comapny
export const POOL_DATA_COMPANY = {
  UserPoolId: import.meta.env.VITE_JAMS_COMPANY_USER_POOL_ID,
  ClientId: import.meta.env.VITE_JAMS_COMPANY_CLIENT_ID,
}
